import { uiContext } from "@/components/UiProvider";
import { useContext } from "react";

const useUiDispatch = () => {
  const { uiDispatch } = useContext(uiContext);
  return uiDispatch;
};

export default useUiDispatch;
